import React from "react";
import "./footer.css";
function Footer() {
  return <footer className="footer">© Designed & Built by Özer Öztürk</footer>;
}

export default Footer;
